import { clearAllSnapshots, listSnapshots } from "./snapshots.ts";

export const LOCAL_DATA_WARN_BYTES = 10 * 1024 * 1024 * 1024;

const PINNED_SKILL_KEY = "bigpp.pinnedSkillIds";

export const formatBytes = (n: number): string => {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const computeLocalDataSize = async (): Promise<{ bytes: number; snapshots: number }> => {
  const snaps = await listSnapshots().catch((): [] => []);
  let bytes = snaps.reduce((sum, s) => sum + s.sizeBytes, 0);
  try {
    const raw = window.localStorage.getItem(PINNED_SKILL_KEY);
    if (raw) bytes += raw.length;
  } catch {
    // ignore
  }
  return { bytes, snapshots: snaps.length };
};

export const clearLocalData = async (): Promise<void> => {
  await clearAllSnapshots().catch(() => undefined);
  try {
    window.localStorage.removeItem(PINNED_SKILL_KEY);
  } catch {
    // ignore
  }
};
